/* ============================================================================
   Mega Menu (SKRT) — assets/skrt-mega-menu.js  (v2: mockup-faithful)
   ----------------------------------------------------------------------------
   Alpine.js plugin: skrtMegaMenu component + skrtDrawer store.
   SKRT-namespaced, so it does not interfere with Concept's Alpine stores.
   Loaded once through an SKRT-owned guard.

   Sticky behaviour is CSS-native (position: sticky on .header), no scroll
   listener needed. JS sets --menu-top so fixed mega-menu lands below header.
   ========================================================================== */

(function () {
  'use strict';

  // Guard against duplicate execution when the section and layout both load this asset.
  if (window.__skrtMegaMenuLoaded) return;
  window.__skrtMegaMenuLoaded = true;

  // Body scroll lock helper (replaces dependency on parent theme xPopup)
  function lockBody() {
    var b = document.body;
    if (b.classList.contains('skrt-drawer-open')) return;
    b.dataset.skrtScrollY = String(window.scrollY || window.pageYOffset || 0);
    b.classList.add('skrt-drawer-open');
    b.style.position = 'fixed';
    b.style.top = '-' + b.dataset.skrtScrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
  }
  function unlockBody() {
    var b = document.body;
    var y = parseInt(b.dataset.skrtScrollY || '0', 10);
    b.classList.remove('skrt-drawer-open');
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    delete b.dataset.skrtScrollY;
    window.scrollTo(0, y);
  }

  // Drawer store
  document.addEventListener('alpine:init', function () {
    if (!window.Alpine) return;
    Alpine.store('skrtDrawer', {
      show: false,
      openItems: new Set(),
      open: function () { lockBody(); this.show = true; },
      close: function () { unlockBody(); this.show = false; this.openItems.clear(); },
      toggleItem: function (id) {
        if (this.openItems.has(id)) this.openItems.delete(id);
        else this.openItems.add(id);
      },
      isOpen: function (id) { return this.openItems.has(id); }
    });
  });

  // Move #CartDrawer to be a direct child of <body>, last in DOM order.
  // Third-party widgets (Shopify Inbox, Smile.io rewards, Klaviyo popups)
  // inject themselves at body level with very high z-index; if our drawer
  // is buried inside our section's DOM it loses to them on equal z-index
  // tie-breaks (later DOM element wins). Moving the drawer to body's end
  // every time the cart opens guarantees it sits above any widget injected
  // before our click — and re-runs the move on each click so widgets that
  // re-inject mid-session can't fall back on top.
  function skrtMoveCartDrawerToBody() {
    var cd = document.getElementById('CartDrawer');
    if (cd && cd.parentElement !== document.body) {
      document.body.appendChild(cd);
    }
  }
  // Run once after Alpine processes the page (after our section + widgets load)
  if (document.readyState === 'complete') {
    setTimeout(skrtMoveCartDrawerToBody, 0);
  } else {
    window.addEventListener('load', function () { setTimeout(skrtMoveCartDrawerToBody, 0); });
  }
  window.skrtMoveCartDrawerToBody = skrtMoveCartDrawerToBody;

  // --- Restore the theme's signature X cursor over drawer/modal overlays ---
  // When a modal opens the theme adds body.has-modal-open, which (1) hides the
  // global <mouse-cursor> (display:none/opacity:0/visibility:hidden) and (2)
  // the overlay sits at z-index 2147483647 while the cursor is only z-50. The
  // overlay's `cursor:none` then hides the real pointer with no X to replace
  // it — the mouse appears to vanish. Rescue: force the cursor visible, give it
  // the same max z-index, and move it to the END of <body> (after our
  // body-mounted cart drawer) so it wins the equal-z stacking tie and paints
  // above the overlay. pointer-events:none on the cursor means clicks still
  // pass through to the overlay (which closes the drawer). The cursor stays
  // 0x0/invisible until the overlay-element's hover adds .active, so forcing it
  // "visible" is harmless when the pointer isn't over an overlay.
  function skrtRescueCursor() {
    var mc = document.querySelector('mouse-cursor');
    // match both 'has-modal-open' (settled) and 'has-modal-opening' (animating)
    if (!mc || !/has-modal-open/.test(document.body.className)) return;
    mc.style.setProperty('display', 'flex', 'important');
    mc.style.setProperty('opacity', '1', 'important');
    mc.style.setProperty('visibility', 'visible', 'important');
    mc.style.setProperty('z-index', '2147483647', 'important');
    if (mc !== document.body.lastElementChild) document.body.appendChild(mc);
  }
  // Re-apply across the modal's open animation (~360ms) in case the theme
  // re-hides the cursor a frame or two after our first pass.
  function skrtRescueCursorBurst() {
    skrtRescueCursor();
    [60, 180, 360].forEach(function (t) { setTimeout(skrtRescueCursor, t); });
  }
  if (window.MutationObserver) {
    new MutationObserver(skrtRescueCursorBurst)
      .observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  window.skrtRescueCursor = skrtRescueCursor;

  // Global helper to open parent theme's native search popup from anywhere
  // (used by the mobile-only search button next to the hamburger).
  window.skrtOpenSearch = function () {
    setTimeout(function () {
      if (!window.Alpine) return;
      try {
        var sc = document.querySelector('.section-skrt-mega-menu .header-search');
        if (sc && window.Alpine.$data) {
          var data = window.Alpine.$data(sc);
          if (data && typeof data.open === 'function') data.open('open_search');
        }
        var xm = window.Alpine.store('xModal');
        if (xm && typeof xm.setActiveElement === 'function') xm.setActiveElement('SearchOpen');
      } catch (e) {}
    }, 0);
  };

  // Carousel-row scroll affordance: stamps data-scrollable / data-at-start /
  // data-at-end on every .mm-row-trackwrap; the section CSS drives the edge
  // fades + hover paddles off those attributes. Tracks inside display:none
  // tab panels measure 0, so the Alpine component re-runs the updaters
  // (window.skrtRefreshRowTracks) whenever a panel opens or a tab switches.
  var skrtTrackUpdaters = [];
  function skrtInitRowTracks() {
    document.querySelectorAll('.section-skrt-mega-menu .mm-row-trackwrap').forEach(function (wrap) {
      if (wrap.dataset.skrtScrollInit) return;
      wrap.dataset.skrtScrollInit = '1';
      var track = wrap.querySelector('.mm-row-track');
      if (!track) return;
      var set = function (key, val) {
        // write only on real change — every dataset write invalidates styles
        // on the snap container, and Chrome cancels an in-flight smooth
        // scroll by re-snapping (to 0) when that happens mid-animation
        if (wrap.dataset[key] !== val) wrap.dataset[key] = val;
      };
      var update = function () {
        var max = track.scrollWidth - track.clientWidth;
        set('scrollable', (max > 4) ? 'true' : 'false');
        set('atStart', (track.scrollLeft < 8) ? 'true' : 'false');
        set('atEnd', (track.scrollLeft > max - 8) ? 'true' : 'false');
      };
      // debounce until the scroll settles for the same reason — no attribute
      // mutations while the paddle's smooth scrollBy is animating
      var settleT = null;
      track.addEventListener('scroll', function () {
        if (settleT) clearTimeout(settleT);
        settleT = setTimeout(update, 140);
      }, { passive: true });
      skrtTrackUpdaters.push(update);
      update();
    });
  }
  // ---- product-title auto-fit ------------------------------------------
  // Scale each title's font to the largest size that still fits its fixed
  // 56px box, so titles MAXIMIZE their space regardless of length (a true
  // fit-to-box, far more precise than character-count tiers). The inner <a>
  // is display:block/width:100% so its scrollHeight reports the true wrapped
  // height even though the parent box clips + flex-centers. Measurement
  // (scrollHeight) works in occluded windows — no rAF needed. Titles in a
  // closed (hidden) panel measure 0, so we fit on panel open / tab switch /
  // resize via skrtRefreshRowTracks. Already-fitted titles are skipped until
  // a resize (width change) forces a refit.
  function skrtFitTitle(box) {
    if (box.offsetParent === null) return;     // hidden panel — fit when shown
    var inner = box.querySelector('a') || box;
    var H = box.clientHeight, W = box.clientWidth;
    if (!H || !W) return;
    var lo = 11, hi = 22, best = 11;           // px bounds
    for (var i = 0; i < 8; i++) {              // binary search, ~0.04px precision
      var mid = (lo + hi) / 2;
      box.style.fontSize = mid + 'px';
      if (inner.scrollHeight <= H + 0.5 && inner.scrollWidth <= W + 0.5) {
        best = mid; lo = mid;
      } else {
        hi = mid;
      }
    }
    box.style.fontSize = best.toFixed(2) + 'px';
    box.dataset.skrtFit = '1';
  }
  function skrtFitTitles(force) {
    document.querySelectorAll('.section-skrt-mega-menu .product-card__title').forEach(function (box) {
      if (force) box.dataset.skrtFit = '';
      if (box.dataset.skrtFit === '1') return;
      skrtFitTitle(box);
    });
  }
  window.skrtFitTitles = skrtFitTitles;
  window.skrtRefreshRowTracks = function () {
    skrtTrackUpdaters.forEach(function (fn) { fn(); });
    skrtFitTitles(false);
  };

  // Paddle click → one "page" of cells left/right. Drives scrollLeft via
  // rAF instead of scrollBy({behavior:'smooth'}): compositor smooth scrolls
  // on this fixed, transform-transitioned subtree start ~500ms late (and are
  // canceled outright while the panel's open transition runs). The target is
  // snap-aligned (cell pitch) so the mandatory snap agrees with the landing.
  window.skrtRowScroll = function (btn, dir) {
    var wrap = btn.parentElement;
    var track = wrap && wrap.querySelector('.mm-row-track');
    if (!track) return;
    var pitch = 200; // cell 186 + gap 14 fallback
    var cell = track.querySelector('.mm-row-cell');
    if (cell) {
      var cs = getComputedStyle(track);
      pitch = cell.getBoundingClientRect().width + (parseFloat(cs.columnGap) || 14);
    }
    var max = track.scrollWidth - track.clientWidth;
    var page = Math.max(1, Math.floor(track.clientWidth / pitch)) * pitch;
    var target = Math.round((track.scrollLeft + dir * page) / pitch) * pitch;
    target = Math.max(0, Math.min(max, target));
    var from = track.scrollLeft, delta = target - from;
    if (!delta) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.scrollLeft = target;
      return;
    }
    if (track._skrtAnim) cancelAnimationFrame(track._skrtAnim);
    if (track._skrtAnimFb) clearTimeout(track._skrtAnimFb);
    var dur = 380, t0 = performance.now(), ticked = false;
    var step = function (now) {
      ticked = true;
      var p = Math.min(1, (now - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
      track.scrollLeft = from + delta * e;
      if (p < 1) track._skrtAnim = requestAnimationFrame(step);
    };
    track._skrtAnim = requestAnimationFrame(step);
    // rAF is suspended in hidden/occluded windows — land instantly there
    // rather than silently doing nothing
    track._skrtAnimFb = setTimeout(function () {
      if (!ticked) {
        cancelAnimationFrame(track._skrtAnim);
        track.scrollLeft = target;
      }
    }, 120);
  };
  var skrtTrackRaf = null;
  window.addEventListener('resize', function () {
    if (skrtTrackRaf) cancelAnimationFrame(skrtTrackRaf);
    skrtTrackRaf = requestAnimationFrame(function () {
      skrtFitTitles(true);                 // card width changed — refit titles
      window.skrtRefreshRowTracks();
    });
  });
  if (document.readyState !== 'loading') {
    setTimeout(skrtInitRowTracks, 0);
  } else {
    document.addEventListener('DOMContentLoaded', skrtInitRowTracks);
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(skrtInitRowTracks, 0); });

  // Section component
  window.skrtMegaMenu = function (opts) {
    opts = opts || {};
    return {
      open: null,             // index of open desktop mega-menu, or null
      activeTabs: {},          // { [blockId]: tabIndex }
      openMotion: opts.openMotion || 'hover',

      _hoverTimeout: null,
      _openTimeout: null,
      _tabTimeout: null,
      _resizeObs: null,

      init: function () {
        var self = this;

        // Compute --menu-top once mounted, on resize, and after font load
        this._updateMenuTop();
        this._resizeObs = new ResizeObserver(function () { self._updateMenuTop(); });
        this._resizeObs.observe(this.$el);

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () { self._updateMenuTop(); });
        }
        window.addEventListener('resize', function () { self._updateMenuTop(); });

        // Dock the strip into the native header's empty center slot
        // (.header__navigation — the slot the fd-empty menu leaves vacant)
        // on wide screens, so logo + nav + icons share one row. Below
        // 1100px the slot is too narrow; the strip returns to its own row.
        // The wrapper carries .section-skrt-mega-menu so all scoped CSS
        // keeps applying to the moved subtree.
        this._homeSection = this.$el.parentElement;
        this._dockWrap = null;
        var applyDock = function () {
          var slot = document.querySelector('.header .header__navigation');
          if (!slot || !self._homeSection) return;
          // Zombie guard: when the editor re-renders this section or the
          // header, this component instance can outlive its DOM. A detached
          // strip or home section means a fresh instance owns the menu now.
          if (!self.$el.isConnected || !self._homeSection.isConnected) return;
          // Purge dock wrappers left behind by dead instances (editor
          // re-renders) so two strips can never coexist in the header.
          document.querySelectorAll('.header .skrt-docked').forEach(function (w) {
            if (w !== self._dockWrap) w.remove();
          });
          // Double-menu guard, belt for the CSS suppression braces: if a theme
          // update ever renames .header__menu so the section CSS stops matching,
          // force-hide any native nav sharing the header slot. Our own strip
          // (div.skrt-nav-strip) is the only exception.
          slot.querySelectorAll('nav').forEach(function (n) {
            if (!n.closest('.skrt-nav-strip')) n.style.setProperty('display', 'none', 'important');
          });
          // Dock EVERYWHERE >=1100px, including the theme editor (per Jacob:
          // the editor preview must match the storefront). Editor re-renders
          // used to mangle a reparented strip; that is now handled by the
          // zombie guard + stale-wrapper purge above and the section:load
          // self-healing below, instead of disabling the dock in designMode.
          // _noDockBelow is the self-measured safety: if a dock ever
          // overflows the header (long menu labels, big logo), we record
          // the width it failed at and stay on the own-row layout there.
          var wantDock = window.innerWidth >= 1100 &&
            window.innerWidth > (self._noDockBelow || 0);
          var dockedNow = !!(self._dockWrap && self.$el.parentElement === self._dockWrap);
          if (wantDock && !dockedNow) {
            if (!self._dockWrap) {
              self._dockWrap = document.createElement('div');
              self._dockWrap.className = 'section-skrt-mega-menu skrt-docked';
            }
            slot.appendChild(self._dockWrap);
            self._dockWrap.appendChild(self.$el);
            requestAnimationFrame(function () {
              if (document.documentElement.scrollWidth > document.documentElement.clientWidth + 1) {
                self._noDockBelow = window.innerWidth + 20;
                applyDock();
              }
            });
          } else if (!wantDock && dockedNow) {
            self._homeSection.appendChild(self.$el);
            if (self._dockWrap.parentElement) self._dockWrap.parentElement.removeChild(self._dockWrap);
          }
          self._updateMenuTop();
        };
        this._applyDock = applyDock;
        applyDock();
        window.addEventListener('resize', applyDock);
        // resize can be missed (and is noisy) — the breakpoint cross itself
        // is the reliable signal
        if (window.matchMedia) {
          var dockMq = window.matchMedia('(min-width: 1100px)');
          if (dockMq.addEventListener) dockMq.addEventListener('change', applyDock);
          else if (dockMq.addListener) dockMq.addListener(applyDock);
        }

        // Theme-editor live reload, self-healing dock:
        // - header re-rendered: the docked strip lived INSIDE the old header
        //   DOM and was destroyed with it. Re-render this section via the
        //   Section Rendering API; the fresh strip (auto-initialized by
        //   Alpine) docks itself into the new header.
        // - this section re-rendered: the fresh instance purges the old
        //   docked wrapper in its own applyDock; nothing to do here.
        document.addEventListener('shopify:section:load', function (ev) {
          var sec = ev && ev.target;
          if (!sec || !sec.querySelector) return;
          if (!self._homeSection || !self._homeSection.isConnected) return;
          if (sec.querySelector('.header__navigation') && !document.querySelector('.skrt-nav-strip')) {
            var sid = (self._homeSection.id || '').replace(/^shopify-section-/, '');
            if (!sid) return;
            fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid))
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var t = document.createElement('template');
                t.innerHTML = html.trim();
                var root = t.content.firstElementChild;
                self._homeSection.innerHTML = root ? root.innerHTML : html;
              })
              .catch(function () {});
            return;
          }
          if (sec.querySelector('.section-skrt-mega-menu, .header')) {
            self.open = null;
            self._updateMenuTop();
            if (self._applyDock) self._applyDock();
          }
        });

        // Theme-editor block selection: when merchant clicks a block in the
        // editor sidebar, open the corresponding mega-menu panel so they can
        // see what they're editing live.
        document.addEventListener('shopify:block:select', function (ev) {
          var blockId = ev && ev.detail && ev.detail.blockId;
          if (!blockId) return;
          var el = self.$el.querySelector('[data-skrt-block-id="' + blockId + '"]');
          if (!el) return;
          var idx = parseInt(el.dataset.skrtIdx, 10);
          if (!isNaN(idx)) {
            // Has a panel (dropdown / grid / tabbed)
            self.open = idx;
            if (self._hoverTimeout) clearTimeout(self._hoverTimeout);
          } else {
            // Plain link — just scroll to it
            el.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });

        document.addEventListener('shopify:block:deselect', function (ev) {
          var blockId = ev && ev.detail && ev.detail.blockId;
          if (!blockId) return;
          var el = self.$el.querySelector('[data-skrt-block-id="' + blockId + '"]');
          if (el && el.dataset.skrtIdx !== undefined) {
            self.open = null;
          }
        });

        // Esc key closes mega-menu and drawer
        document.addEventListener('keydown', function (ev) {
          if (ev.key === 'Escape') {
            self._clearHoverTimers();
            if (self.open !== null) self.open = null;
            if (window.Alpine) {
              var d = window.Alpine.store('skrtDrawer');
              if (d && d.show) d.close();
            }
          }
        });

        // Click-outside-to-close (desktop) for our mega-menus
        document.addEventListener('click', function (ev) {
          if (self.open === null) return;
          if (!self.$el.contains(ev.target)) {
            self._clearHoverTimers();
            self.open = null;
          }
        });

        // Safety-net click-outside for parent theme's native search popup.
        // parent theme's snippet has x-on:click.away built in, but in some edge cases
        // (focus shifted, popup z-index conflict) it can miss. This handler
        // calls parent theme's own close() method directly via Alpine.$data.
        document.addEventListener('click', function (ev) {
          if (!window.Alpine || !window.Alpine.$data) return;
          var sc = document.querySelector('.section-skrt-mega-menu .header-search');
          if (!sc) return;
          var popup = sc.querySelector('.x-search-popup');
          if (!popup || popup.classList.contains('popup-hidden')) return;
          if (sc.contains(ev.target)) return;
          try {
            var data = window.Alpine.$data(sc);
            if (data && typeof data.close === 'function') {
              data.close('open_search');
            }
            var xm = window.Alpine.store('xModal');
            if (xm && typeof xm.removeFocus === 'function') xm.removeFocus();
          } catch (e) {}
        });
      },

      _updateMenuTop: function () {
        // Anchor the fixed panels below the whole (sticky) header when the
        // strip is docked inside it; below the strip itself when it sits on
        // its own row (<1100px).
        var host = this.$el.closest('.header-section') || this.$el;
        var rect = host.getBoundingClientRect();
        var top = Math.max(0, rect.bottom);
        if (host === this.$el && rect.top <= 0) {
          top = rect.height;
        }
        this.$el.style.setProperty('--menu-top', top + 'px');
      },

      openPanel: function (idx, hasPanel) {
        if (!hasPanel) { this.open = null; return; }
        if (this._hoverTimeout) clearTimeout(this._hoverTimeout);
        if (this.open === idx) return;
        var self = this;
        if (this._openTimeout) clearTimeout(this._openTimeout);
        // Hover intent: a closed menu needs a deliberate 140ms dwell before
        // it opens, so a cursor merely crossing the nav strip never triggers
        // a panel. Moving between items while one is already open stays
        // snappier (75ms) so browsing along the bar feels responsive.
        this._openTimeout = setTimeout(function () {
          if (self._tabTimeout) clearTimeout(self._tabTimeout);
          self._updateMenuTop(); // re-anchor in case the page scrolled since load
          self.open = idx;
          if (window.skrtRefreshRowTracks) setTimeout(window.skrtRefreshRowTracks, 60);
        }, this.open === null ? 140 : 75);
      },

      closePanel: function () {
        var self = this;
        if (this._openTimeout) clearTimeout(this._openTimeout);
        if (this._tabTimeout) clearTimeout(this._tabTimeout);
        if (this._hoverTimeout) clearTimeout(this._hoverTimeout);
        // Grace period before closing: briefly slipping off the panel edge
        // (or crossing a sub-pixel gap between the nav item and its panel)
        // doesn't slam the menu shut.
        this._hoverTimeout = setTimeout(function () { self.open = null; }, 220);
      },

      togglePanel: function (idx, hasPanel) {
        this._clearHoverTimers();
        if (!hasPanel) { this.open = null; return; }
        this.open = (this.open === idx) ? null : idx;
        if (this.open !== null && window.skrtRefreshRowTracks) setTimeout(window.skrtRefreshRowTracks, 60);
      },

      _clearHoverTimers: function () {
        if (this._openTimeout) clearTimeout(this._openTimeout);
        if (this._hoverTimeout) clearTimeout(this._hoverTimeout);
        if (this._tabTimeout) clearTimeout(this._tabTimeout);
      },

      setTab: function (blockId, tabIdx) {
        if (this._tabTimeout) clearTimeout(this._tabTimeout);
        this.activeTabs[blockId] = tabIdx;
        if (window.skrtRefreshRowTracks) setTimeout(window.skrtRefreshRowTracks, 60);
      },

      // Hover intent for the tab list: a hovered tab only takes over the
      // panel after a 140ms dwell, so a diagonal mouse path from a tab into
      // the product rows can sweep across the tabs below it without
      // switching panels. Clicks (setTab) stay instant.
      hoverTab: function (blockId, tabIdx) {
        var self = this;
        if (this._tabTimeout) clearTimeout(this._tabTimeout);
        if (this.activeTab(blockId, 0) === tabIdx) return;
        this._tabTimeout = setTimeout(function () {
          self.activeTabs[blockId] = tabIdx;
          if (window.skrtRefreshRowTracks) setTimeout(window.skrtRefreshRowTracks, 60);
        }, 140);
      },

      cancelTabHover: function () {
        if (this._tabTimeout) clearTimeout(this._tabTimeout);
      },

      activeTab: function (blockId, fallback) {
        if (this.activeTabs[blockId] === undefined) {
          return (fallback !== undefined) ? fallback : 0;
        }
        return this.activeTabs[blockId];
      }
    };
  };

})();

/* ───────────────────────────────────────────────────────────────────────
   SKRT mega-menu LAZY PANEL LOADING  (performance)
   ------------------------------------------------------------------------
   The mega_tabbed panels ship with EMPTY `.mm-row-track` / `.mm-subgrid`
   shells carrying `data-mm-collection="<handle>"`. The ~350 product cards
   that used to be inlined into every page (~0.5MB of markup) are now
   fetched on first panel-open from:
       /collections/<handle>?view=mm-row   (horizontal track cells)
       /collections/<handle>?view=mm-grid  (static grid cells)
   Those alternate templates render `snippets/skrt-mm-cards.liquid` with
   `{% layout none %}`, returning bare product-card HTML, injected once and
   cached per (handle, mode).

   Integration is DECOUPLED from the Alpine interaction logic: a
   MutationObserver watches the panels' `[open]` / `is-active` toggles, so
   the carefully-tuned hover/tab timing in skrtMegaMenu() is untouched. On
   hover-intent we warm the first tab's cache so cards are usually already
   in flight by the time the panel opens.

   Graceful degradation: with JS off, panels show their row heads + "View
   all" collection links (no cards) — still navigable and crawlable.
   ──────────────────────────────────────────────────────────────────────── */
(function () {
  if (window.__skrtMMLazyLoaded) return;
  window.__skrtMMLazyLoaded = true;

  var SEL = '.mm-row-track[data-mm-collection]:not([data-mm-loaded]), .mm-subgrid[data-mm-collection]:not([data-mm-loaded])';
  var SEL_OPEN = '.megamenu[open] .mm-row-track[data-mm-collection]:not([data-mm-loaded]), .megamenu[open] .mm-subgrid[data-mm-collection]:not([data-mm-loaded])';
  var cache = {}; // "handle|mode" -> Promise<string html>

  function modeOf(el) { return el.classList.contains('mm-subgrid') ? 'grid' : 'row'; }

  // Right-size the thumbnails BEFORE injection. The product-card cells are
  // ~186px, but each <img> ships a full srcset ladder (180w up to the source's
  // native width — 1080..4472w) with NO `sizes` attr when rendered standalone,
  // so the browser assumes 100vw and pulls a giant candidate. `sizes` alone is
  // unreliable (DPR/source-size heuristics), so we CAP the srcset ladder: drop
  // every candidate wider than 600w. A 186px cell at 2x needs ~372px, so 540w
  // is the worst we ever load now — crisp + bounded, the heavy sources can no
  // longer be chosen. Runs on the HTML string before insert, so the oversized
  // fetch never starts.
  var SRCSET_CAP = 600;
  function rightsize(html) {
    if (!html) return html;
    html = html.replace(/srcset="([^"]*)"/g, function (whole, ss) {
      var kept = ss.split(',').map(function (s) { return s.trim(); }).filter(function (s) {
        var m = s.match(/\s(\d+)w$/);
        return !m || parseInt(m[1], 10) <= SRCSET_CAP;
      });
      if (!kept.length) { kept = [ss.split(',')[0].trim()]; } // safety: keep the smallest
      return 'srcset="' + kept.join(', ') + '"';
    });
    // Pin the slot to 360px so the browser selects the 360w candidate (crisp on
    // a 186px cell at 2x); 190px made it pick the 180w candidate (too soft).
    html = html.replace(/<img\b(?![^>]*\bsizes=)/g, '<img sizes="360px"');
    // These cards are fetched only when the user OPENS the menu, so native
    // lazy buys nothing — and it was stalling at currentSrc="" for innerHTML-
    // injected imgs in this fixed/animated panel (they never loaded until a
    // scroll). Load eagerly so the open panel paints its thumbnails at once.
    html = html.replace(/loading=(["'])lazy\1/g, 'loading="eager"');
    return html;
  }

  function fetchCards(handle, mode) {
    var key = handle + '|' + mode;
    if (cache[key]) return cache[key];
    var url = '/collections/' + encodeURIComponent(handle) + '?view=mm-' + mode;
    cache[key] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(rightsize)
      .catch(function () { return ''; });
    return cache[key];
  }

  // Inject cards into one empty shell (idempotent; retries on failure).
  function hydrate(el) {
    if (!el || el.hasAttribute('data-mm-loaded')) return;
    var handle = el.getAttribute('data-mm-collection');
    if (!handle) { el.setAttribute('data-mm-loaded', '1'); return; }
    el.setAttribute('data-mm-loaded', '1'); // optimistic: blocks re-entry while fetch is in flight
    fetchCards(handle, modeOf(el)).then(function (html) {
      if (html) {
        el.insertAdjacentHTML('beforeend', html);
        el.removeAttribute('aria-busy');
      } else {
        el.removeAttribute('data-mm-loaded'); // empty/failed -> allow a later retry
      }
      if (window.skrtRefreshRowTracks) window.skrtRefreshRowTracks();
      if (window.skrtFitTitles) window.skrtFitTitles(true);
    });
  }

  // Hydrate only shells inside an OPEN panel AND a VISIBLE (active) tab —
  // never closed/hidden ones, so nothing loads until the user opens a panel.
  window.skrtHydrateScope = function (scope) {
    if (!scope) return;
    scope.querySelectorAll(SEL_OPEN).forEach(function (el) {
      if (el.offsetParent !== null && getComputedStyle(el).display !== 'none') hydrate(el);
    });
  };

  // From a card <img srcset>, grab the ~360w (2x the cell) candidate URL so we
  // preload exactly what the panel will display, not the 1080w fallback.
  function pick360(srcset) {
    var parts = srcset.split(','), best = null, bestDiff = 1e9;
    for (var i = 0; i < parts.length; i++) {
      var seg = parts[i].trim().split(/\s+/), url = seg[0], w = parseInt(seg[1], 10);
      if (!url || !w) continue;
      var diff = Math.abs(w - 360);
      if (diff < bestDiff) { bestDiff = diff; best = url; }
    }
    return best ? (best.indexOf('//') === 0 ? 'https:' + best : best) : null;
  }

  // Preload the thumbnails referenced in a fetched fragment (HTTP-cache warm),
  // so when the panel injects them they paint instantly instead of fetching.
  function warmImages(html) {
    if (!html) return;
    var re = /srcset="([^"]+)"/g, m;
    while ((m = re.exec(html))) {
      var u = pick360(m[1]);
      if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; }
    }
  }

  // Warm cache for an item's first (default-active) tab — fired on hover intent
  // so BOTH the card HTML and its right-sized images are usually ready by the
  // time the panel opens (the perceived-speed win).
  window.skrtPrefetchItem = function (li) {
    if (!li) return;
    var firstPanel = li.querySelector('.mm-panel-content') || li;
    firstPanel.querySelectorAll(SEL).forEach(function (el) {
      var h = el.getAttribute('data-mm-collection');
      if (h) fetchCards(h, modeOf(el)).then(warmImages);
    });
  };

  // Idle warm: shortly AFTER the page settles, pre-warm the menu so the very
  // first hover is already a cache hit. For each tabbed item's default tab we
  // fetch every row's card HTML (cheap, makes the cards inject instantly) but
  // only preload the FIRST row's thumbnails (the part seen immediately). Gated
  // to desktop (menu is hidden <=1180px) and skipped on data-saver / slow nets.
  var idleWarmed = false;
  function skrtIdleWarm() {
    if (idleWarmed) return;
    idleWarmed = true;
    if (window.innerWidth <= 1180) return;
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g/.test(c.effectiveType || ''))) return;
    document.querySelectorAll('.section-skrt-mega-menu .nav-item').forEach(function (li) {
      var panel = li.querySelector('.mm-panel-content') || li; // default (first) tab
      var shells = panel.querySelectorAll(SEL);
      shells.forEach(function (el, i) {
        var h = el.getAttribute('data-mm-collection');
        if (!h) return;
        var p = fetchCards(h, modeOf(el)); // warm card HTML (cached for open)
        if (i === 0) p.then(warmImages);   // preload images for the first row only
      });
    });
  }
  function scheduleIdleWarm() {
    var fire = function () {
      if (window.requestIdleCallback) { requestIdleCallback(skrtIdleWarm, { timeout: 4000 }); }
      else { setTimeout(skrtIdleWarm, 1500); }
    };
    if (document.readyState === 'complete') { fire(); }
    else { window.addEventListener('load', fire, { once: true }); }
  }

  function wire(sec) {
    if (sec.__skrtLazyWired) return;
    sec.__skrtLazyWired = true;

    // (1) Hydrate on any open / active-tab change.
    var deb;
    new MutationObserver(function () {
      clearTimeout(deb);
      deb = setTimeout(function () { window.skrtHydrateScope(sec); }, 60);
    }).observe(sec, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'], subtree: true });

    // (2) Prefetch the first tab on deliberate hover (intent dwell).
    sec.querySelectorAll('.nav-item').forEach(function (li) {
      var t;
      li.addEventListener('mouseenter', function () {
        t = setTimeout(function () { window.skrtPrefetchItem(li); }, 90);
      }, { passive: true });
      li.addEventListener('mouseleave', function () { clearTimeout(t); }, { passive: true });
    });
  }

  function init() {
    document.querySelectorAll('.section-skrt-mega-menu').forEach(wire);
    scheduleIdleWarm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
